import { render, staticRenderFns } from "./ProjectDelete.vue?vue&type=template&id=bfe6487a&scoped=true&"
import script from "./ProjectDelete.vue?vue&type=script&lang=ts&"
export * from "./ProjectDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe6487a",
  null
  
)

export default component.exports